/** InsCoder WANG.J 2025-11-08 B + Comparison Table Functionality **/

(function() {
  'use strict';
  
  const sectionClass = '.cust-comparison-table';
  
  function initComparisonTable() {
    const sections = document.querySelectorAll(sectionClass);
    
    sections.forEach(section => {
      const tabs = section.querySelectorAll('.comparison-table__tab');
      const tables = section.querySelectorAll('.comparison-table__wrapper');
      
      tabs.forEach(tab => {
        tab.addEventListener('click', function() {
          const tabType = this.getAttribute('data-tab');
          
          // Update active tab
          tabs.forEach(t => {
            t.classList.remove('comparison-table__tab--active');
            t.setAttribute('aria-pressed', 'false');
          });
          this.classList.add('comparison-table__tab--active');
          this.setAttribute('aria-pressed', 'true');
          
          // Show corresponding table
          tables.forEach(table => {
            const tableType = table.getAttribute('data-table');
            if (tableType === tabType) {
              table.classList.remove('comparison-table__wrapper--hidden');
            } else {
              table.classList.add('comparison-table__wrapper--hidden');
            }
          });
        });
      });
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComparisonTable);
  } else {
    initComparisonTable();
  }
  
  // Shopify Theme Editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector(sectionClass)) {
        initComparisonTable();
      }
    });
  }
  
})();

/** InsCoder WANG.J 2025-11-08 E + Comparison Table Functionality **/

